"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var cryptoassets_1 = require("@ledgerhq/cryptoassets");
var logs_1 = require("@ledgerhq/logs");
var bignumber_js_1 = require("bignumber.js");
var invariant_1 = __importDefault(require("invariant"));
var errors_1 = require("@ledgerhq/errors");
var errors_2 = require("../../../errors");
var shared_1 = require("../../../bridge/shared");
var syncAccount_1 = require("../../../libcore/syncAccount");
var scanAccounts_1 = require("../../../libcore/scanAccounts");
var getAccountNetworkInfo_1 = require("../../../libcore/getAccountNetworkInfo");
var getFeesForTransaction_1 = require("../../../libcore/getFeesForTransaction");
var cache_1 = require("../../../cache");
var libcore_broadcast_1 = __importDefault(require("../libcore-broadcast"));
var libcore_signOperation_1 = __importDefault(require("../libcore-signOperation"));
var account_1 = require("../../../account");
var fees_1 = require("../fees");
var transaction_1 = require("../transaction");
var jsHelpers_1 = require("../../../bridge/jsHelpers");
var satstack_1 = require("../satstack");
var explorerConfigAPI = __importStar(require("../../../api/explorerConfig"));
var BtcOld_1 = __importDefault(require("@ledgerhq/hw-app-btc/lib/BtcOld")); // use old implementation of Btc for libcore
var hw_getAddress_1 = require("../hw-getAddress");
var receive = (0, jsHelpers_1.makeAccountBridgeReceive)({
    injectGetAddressParams: function (account) {
        var perCoin = transaction_1.perCoinLogic[account.currency.id];
        if (perCoin && perCoin.injectGetAddressParams) {
            return perCoin.injectGetAddressParams(account);
        }
    }
});
var getCacheKey = function (a, t) {
    return "".concat(a.id, "_").concat(a.blockHeight || 0, "_").concat(t.amount.toString(), "_").concat(String(t.useAllAmount), "_").concat(t.recipient, "_").concat(t.feePerByte ? t.feePerByte.toString() : "", "_").concat(t.utxoStrategy.pickUnconfirmedRBF ? 1 : 0, "_").concat(t.utxoStrategy.strategy, "_").concat(String(t.rbf), "_").concat(t.utxoStrategy.excludeUTXOs
        .map(function (_a) {
        var hash = _a.hash, outputIndex = _a.outputIndex;
        return "".concat(hash, "@").concat(outputIndex);
    })
        .join("+"));
};
var calculateFees = (0, cache_1.makeLRUCache)(function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, getFeesForTransaction_1.getFeesForTransaction)({
                account: a,
                transaction: t
            })];
    });
}); }, getCacheKey);
var createTransaction = function () { return ({
    family: "bitcoin",
    amount: new bignumber_js_1.BigNumber(0),
    utxoStrategy: {
        strategy: 0,
        pickUnconfirmedRBF: false,
        excludeUTXOs: []
    },
    recipient: "",
    rbf: false,
    feePerByte: null,
    networkInfo: null,
    useAllAmount: false,
    feesStrategy: "medium"
}); };
var updateTransaction = function (t, patch) {
    var updatedT = __assign(__assign({}, t), patch);
    if (updatedT.recipient.toLowerCase().indexOf("bc1") === 0) {
        updatedT.recipient = updatedT.recipient.toLowerCase();
    }
    return updatedT;
};
var estimateMaxSpendable = function (_a) {
    var account = _a.account, parentAccount = _a.parentAccount, transaction = _a.transaction;
    return __awaiter(void 0, void 0, void 0, function () {
        var mainAccount, t, s;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    mainAccount = (0, account_1.getMainAccount)(account, parentAccount);
                    return [4 /*yield*/, prepareTransaction(mainAccount, __assign(__assign(__assign({}, createTransaction()), transaction), { recipient: (transaction === null || transaction === void 0 ? void 0 : transaction.recipient) || (0, cryptoassets_1.getAbandonSeedAddress)(mainAccount.currency.id), useAllAmount: true }))];
                case 1:
                    t = _b.sent();
                    return [4 /*yield*/, getTransactionStatus(mainAccount, t)];
                case 2:
                    s = _b.sent();
                    return [2 /*return*/, s.amount];
            }
        });
    });
};
var getTransactionStatus = function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    var errors, warnings, useAllAmount, _a, recipientError, recipientWarning, txInputs, txOutputs, estimatedFees, sumOfInputs, sumOfChanges, totalSpent, amount;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                errors = {};
                warnings = {};
                useAllAmount = !!t.useAllAmount;
                return [4 /*yield*/, (0, shared_1.validateRecipient)(a.currency, t.recipient)];
            case 1:
                _a = _b.sent(), recipientError = _a.recipientError, recipientWarning = _a.recipientWarning;
                if (recipientError) {
                    errors.recipient = recipientError;
                }
                if (recipientWarning) {
                    warnings.recipient = recipientWarning;
                }
                estimatedFees = new bignumber_js_1.BigNumber(0);
                if (!!t.feePerByte) return [3 /*break*/, 2];
                errors.feePerByte = new errors_1.FeeNotLoaded();
                return [3 /*break*/, 5];
            case 2:
                if (!t.feePerByte.eq(0)) return [3 /*break*/, 3];
                errors.feePerByte = new errors_1.FeeRequired();
                return [3 /*break*/, 5];
            case 3:
                if (!!errors.recipient) return [3 /*break*/, 5];
                return [4 /*yield*/, calculateFees(a, t).then(function (res) {
                        txInputs = res.txInputs;
                        txOutputs = res.txOutputs;
                        estimatedFees = res.estimatedFees;
                    }, function (error) {
                        if (error.name === "NotEnoughBalance") {
                            errors.amount = error;
                        }
                        else {
                            throw error;
                        }
                    })];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5:
                sumOfInputs = (txInputs || []).reduce(function (sum, input) { return sum.plus(input.value); }, new bignumber_js_1.BigNumber(0));
                sumOfChanges = (txOutputs || [])
                    .filter(transaction_1.isChangeOutput)
                    .reduce(function (sum, output) { return sum.plus(output.value); }, new bignumber_js_1.BigNumber(0));
                if (txInputs) {
                    (0, logs_1.log)("bitcoin", "".concat(txInputs.length, " inputs, sum: ").concat(sumOfInputs.toString()));
                }
                if (txOutputs) {
                    (0, logs_1.log)("bitcoin", "".concat(txOutputs.length, " outputs, sum of changes: ").concat(sumOfChanges.toString()));
                }
                totalSpent = sumOfInputs.minus(sumOfChanges);
                amount = useAllAmount ? totalSpent.minus(estimatedFees) : t.amount;
                (0, logs_1.log)("bitcoin", "totalSpent ".concat(totalSpent.toString(), " amount ").concat(amount.toString()));
                if (!errors.amount && !amount.gt(0)) {
                    errors.amount = useAllAmount
                        ? new errors_1.NotEnoughBalance()
                        : new errors_1.AmountRequired();
                }
                if (process.env.EXPERIMENTAL_MIN_RELAY_FEE &&
                    estimatedFees.gt(0) &&
                    estimatedFees.lt((0, fees_1.getMinRelayFee)(a.currency))) {
                    warnings.feePerByte = new errors_2.LowerThanMinimumRelayFee();
                }
                else if (amount.gt(0) && estimatedFees.times(10).gt(amount)) {
                    warnings.feeTooHigh = new errors_1.FeeTooHigh();
                }
                return [2 /*return*/, Promise.resolve({
                        errors: errors,
                        warnings: warnings,
                        estimatedFees: estimatedFees,
                        amount: amount,
                        totalSpent: totalSpent,
                        txInputs: txInputs,
                        txOutputs: txOutputs
                    })];
        }
    });
}); };
var inferFeePerByte = function (t, networkInfo) {
    if (t.feesStrategy) {
        var speed = networkInfo.feeItems.items.find(function (item) { return t.feesStrategy === item.speed; });
        if (!speed) {
            return networkInfo.feeItems.defaultFeePerByte;
        }
        return speed.feePerByte;
    }
    return t.feePerByte || networkInfo.feeItems.defaultFeePerByte;
};
var prepareTransaction = function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    var networkInfo, feePerByte;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(a.currency.id === "bitcoin")) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, satstack_1.requiresSatStackReady)()];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                networkInfo = t.networkInfo;
                if (!!networkInfo) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, getAccountNetworkInfo_1.getAccountNetworkInfo)(a)];
            case 3:
                networkInfo = (_a.sent());
                (0, invariant_1["default"])(networkInfo && networkInfo.family === "bitcoin", "bitcoin networkInfo expected");
                _a.label = 4;
            case 4:
                feePerByte = inferFeePerByte(t, networkInfo);
                if (t.networkInfo === networkInfo &&
                    (feePerByte === t.feePerByte || feePerByte.eq(t.feePerByte || 0)) // nothing changed
                ) {
                    return [2 /*return*/, t];
                }
                return [2 /*return*/, __assign(__assign({}, t), { networkInfo: networkInfo, feePerByte: feePerByte })];
        }
    });
}); };
var preload = function () { return __awaiter(void 0, void 0, void 0, function () {
    var explorerConfig;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, explorerConfigAPI.preload()];
            case 1:
                explorerConfig = _a.sent();
                return [2 /*return*/, {
                        explorerConfig: explorerConfig
                    }];
        }
    });
}); };
var hydrate = function (maybeConfig) {
    if (maybeConfig && maybeConfig.explorerConfig) {
        explorerConfigAPI.hydrate(maybeConfig.explorerConfig);
    }
};
var currencyBridge = {
    scanAccounts: function (arg) {
        return (0, scanAccounts_1.scanAccounts)(__assign(__assign({}, arg), { getAddressFn: function (transport) {
                var btc = new BtcOld_1["default"](transport);
                return function (opts) { return (0, hw_getAddress_1.getAddressWithBtcInstance)(transport, btc, opts); };
            } }));
    },
    preload: preload,
    hydrate: hydrate
};
var accountBridge = {
    estimateMaxSpendable: estimateMaxSpendable,
    createTransaction: createTransaction,
    updateTransaction: updateTransaction,
    prepareTransaction: prepareTransaction,
    getTransactionStatus: getTransactionStatus,
    receive: receive,
    sync: syncAccount_1.sync,
    signOperation: libcore_signOperation_1["default"],
    broadcast: function (_a) {
        var account = _a.account, signedOperation = _a.signedOperation;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                calculateFees.reset();
                return [2 /*return*/, (0, libcore_broadcast_1["default"])({
                        account: account,
                        signedOperation: signedOperation
                    })];
            });
        });
    }
};
exports["default"] = {
    currencyBridge: currencyBridge,
    accountBridge: accountBridge
};
//# sourceMappingURL=libcore.js.map